import { Visibility } from "@material-ui/icons";
import CircleIcon from '@mui/icons-material/Circle';
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { Col, FloatingLabel, Form, InputGroup } from "react-bootstrap";
import { useGetDivisionListQuery } from "../../../features/Dispatch/DispatchSlice";
import OrderDetailsMin from "../../Dispatch/SamedayDispatch/OrderDetails/OrderDetailsMin";
import Wrapper from "../../Wrapper";
import RadioButton from "../../designSystem/RadioButton";

const dummyData = [
    {
        id: 1,
        readyTime: "2025-01-21 10:00:00 AM",
        accountNo: "LVM785",
        orderNo: "784513",
        vehicle: "Truck",
        service: "Direct",
        from: 145,
        to: 48,
        pcs: 123,
        wgt: 48,
        driverNo: 123,
        waybill: 12345,
        pay: 0.00,
        charges: 0.00,
        pod: true,
        verify: false,
    },
    {
        id: 2,
        readyTime: "2025-01-21 2:30:00 PM",
        accountNo: "MAX124",
        orderNo: "784514",
        vehicle: "Tractor",
        service: "Direct",
        from: 200,
        to: 48,
        pcs: 123,
        wgt: 48,
        driverNo: 123,
        waybill: 12345,
        pay: 0.00,
        charges: 0.00,
        pod: false,
        verify: false,
    },
    {
        id: 3,
        readyTime: "2025-01-22 9:15:00 AM",
        accountNo: "CAR012",
        orderNo: "784513",
        vehicle: "Truck",
        service: "Direct",
        from: 145,
        to: 48,
        pcs: 123,
        wgt: 48,
        driverNo: 123,
        waybill: 12345,
        pay: 0.00,
        charges: 0.00,
        pod: true,
        verify: false,
    },
];


const OrderMaintenance = () => {
    const { data: divisionList } = useGetDivisionListQuery();
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [divisionId, setDivisionId] = useState(null);
    const [RadioValue, setRadioChange] = useState(null);

    const columns = useMemo(
        () => [
            {
                field: "actions",
                headerName: "Actions",
                width: 80,
                renderCell: (params) => {
                    const onClick = async (e) => {
                        e.stopPropagation();
                        setSelectedOrder({
                            orderId: 1044,
                            orderNumber: 10000799,
                            orderStatus: "Open",
                            readyDate: "2024-12-19 01:00",
                            emailAddress: "jtesttt@lvm.com",
                            accountNo: "TST0361",
                            customer: "tst",
                            consignorName: "Express Ltd",
                            pickupStreetNumber: 5026,
                            pickupStreetName: "Service Rd",
                            pickupUnit: "120",
                            pickupCity: "Burlington",
                            pickupCountry: "CAN",
                            pickupProvince: "ON",
                            pickupPostalCode: "L7L 5Y7",
                            pickupPhoneNumber: "4789568456",
                            pickupDriver: null,
                            pickupAppointment: "2024-03-11T15:21",
                            pickupContact: "Roseee",
                            pickupOpeningTime: "2023-11-16T13:00:00.000Z",
                            pickupClosingTime: "2023-11-16T23:30:00.000Z",
                            pickupContactEmail: "sam@ex.com",
                            pickupReference: null,
                            consigneeName: "Jisna",
                            dropoffStreetNumber: 123,
                            dropoffStreetName: "Drew",
                            dropoffUnit: "100",
                            dropoffCity: "Abbeville",
                            dropoffCountry: "CAN",
                            dropoffProvince: "AB",
                            dropoffPostalCode: "L6Y 5Y6",
                            dropoffPhoneNumber: "4587459856",
                            dropoffDriver: null,
                            dropoffAppointment: "2024-03-12T17:01",
                            dropoffContact: "JISNA",
                            dropoffOpeningTime: "2024-02-13T05:30:00.000Z",
                            dropoffClosingTime: "02:00",
                            dropoffContactEmail: "j@lvm.com",
                            dropoffReference: null,
                            vehicle: "CWTVEHICLE",
                            service: "DISTRIBUTION",
                            pcs: 1,
                            weight: 222,
                            weightTypeId: 2,
                            reference: "1000",
                            accessorialCode: "",
                            unit: "0",
                            spot: "0",
                            ft: "0",
                            dimWgt: "0",
                            accountInformationNotes: "null",
                            pickupInformationNotes: null,
                            dropoffInformationNotes: null,
                            pickupAccessorialCodes: [],
                            dropoffAccessorialCodes: [],
                            orderLevelAccessorialCodes: [],
                            dispatcherNotes: null,
                            tripNo: null,
                            pickupPriority: null,
                            dropoffPriority: null,
                            expiryTime: "",
                            orderProductDescriptionsList: [],
                        });
                    };

                    return (
                        <div className="action_btn">
                            <span className="view_btn" onClick={onClick}>
                                <Visibility />
                            </span>
                        </div>
                    );
                },
            },
            { field: "readyTime", headerName: "Ready time", width: 120 },
            { field: "accountNo", headerName: "Account No.", width: 100 },
            { field: "orderNo", headerName: "Order No.", width: 100 },
            { field: "vehicle", headerName: "Vehicle", width: 100 },
            { field: "service", headerName: "Service", width: 100 },
            { field: "from", headerName: "From", width: 100 },
            { field: "to", headerName: "To", width: 100 },
            { field: "pcs", headerName: "Pcs", width: 100 },
            { field: "wgt", headerName: "Wgt", width: 100 },
            { field: "driverNo", headerName: "Driver No.", width: 100 },
            { field: "waybill", headerName: "Waybill", width: 100 },
            { field: "pay", headerName: "Pay", width: 100 },
            { field: "charges", headerName: "Charges", width: 100 },
            {
                field: "pod", headerName: "POD", width: 100, renderCell: (params) => {
                    return (
                        <div>
                            {params.value ? (
                                <CircleIcon style={{ color: "green" }} />
                            ) : (
                                <CircleIcon style={{ color: "grey" }} />
                            )}
                        </div>
                    );
                },
            },
            {
                field: "verify", headerName: "Verify", width: 100, renderCell: () => {
                    return (
                        <Form>
                            <Form.Check
                                type="checkbox"
                                id="checkbox1"
                            />
                        </Form>
                    );
                },
            },
        ],
        []
    );

    const rows = useMemo(() => {
        return dummyData?.map((order) => ({
            id: order.id,
            ...order,
            readyDate: new Date(order.readyDate).toLocaleString(),
        }));
    }, []);

    const handleRadioChange = (e) => setRadioChange(e.target.value);
    const handleSelectDivision = (e) => setDivisionId(e.target.value);

    return (
        <Wrapper>
            <h3>Order Maintenance & Post Accepted</h3>
            {selectedOrder && (
                <OrderDetailsMin
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                    divisionId={divisionId}
                    shouldShowGrossPriceSection
                />

            )}

            <Col md={12} className="d-flex flex-column flex-md-row justify-content-between table-back p-3 mb-3 align-items-center gap-2">
                <Col sm={12} md={5}>
                    <div className="d-flex gap-2">
                        <Col md={8}>
                            <InputGroup className="h-100">
                                <InputGroup.Text
                                    style={{ backgroundColor: "#f6f6f6", border: 0 }}
                                >
                                    <span>
                                        <i className="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Search"
                                    // value={searchValue}
                                    // onChange={handleGlobalSearch}
                                    style={{
                                        border: 0,
                                        borderRadius: "0 4px 4px 0",
                                        backgroundColor: "#f6f6f6",
                                    }}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={4}>
                            <FloatingLabel controlId="floatingSelectGrid" label="Select division">
                                <Form.Select
                                    aria-label="Floating label select example"
                                    name="divisionId"
                                    value={divisionId || ""}
                                    onChange={handleSelectDivision}
                                >
                                    <option value="">Select</option>
                                    {divisionList?.data?.map((data, index) => (
                                        <option key={index} value={data?.divisionId}>
                                            {data?.divisionName}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </div>
                </Col>
                <Col sm={12} md={5}>
                    <div className="d-flex gap-2">
                        <Col md={12}>
                            <div className="d-flex  align-items-center gap-3 border rounded px-3 py-2">
                                <RadioButton
                                    label="On hold"
                                    name="orderType"
                                    value="OnHold"
                                    checked={RadioValue === "OnHold"}
                                    onChange={handleRadioChange}
                                />
                                <RadioButton
                                    label="Missing"
                                    name="orderType"
                                    value="Missing"
                                    checked={RadioValue === "Missing"}
                                    onChange={handleRadioChange}
                                />
                                <RadioButton
                                    label="Accepted"
                                    name="orderType"
                                    value="Accepted"
                                    checked={RadioValue === "Accepted"}
                                    onChange={handleRadioChange}
                                />
                            </div>
                        </Col>
                    </div>
                </Col>
            </Col>

            <Box sx={{ height: 600, width: "100%" }} className="table-back">
                <DataGrid rows={rows} columns={columns} />
            </Box>
        </Wrapper>
    );
};

export default OrderMaintenance;
